import { InputMaybe, OrderAttributePayload, OrderServicePayload } from "@stepapp/core/apiTypes";

export const parseAttributesToEstimate = (attributes: InputMaybe<OrderAttributePayload>[]) => {
  return (
    attributes?.map((attribute) => ({
      attributeId: attribute?.attributeId || "",
      valueIds: attribute?.valueId || [],
      quantity: attribute?.quantity || 0,
    })) || []
  );
};

export const parseServicesToEstimate = (services: InputMaybe<OrderServicePayload>[]) => {
  return (
    services?.flatMap((service) =>
      service?.serviceId && service?.variants
        ? service.variants
            .filter((variant) => variant?.quantity && variant?.variantId)
            .map((variant) => ({
              id: service?.serviceId,
              qty: variant?.quantity,
              variantId: variant?.variantId,
            }))
        : [],
    ) || []
  );
};
